import React from "react";
import { PHOTOS } from "@/assets/images";

const ABOUT_IMG = PHOTOS.croissantsLogo;

export default function About({ t }) {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative bg-[#F5F2EB] py-24 sm:py-32"
    >
      <div className="mx-auto max-w-7xl px-6 sm:px-10 lg:px-16">
        <div className="grid grid-cols-1 gap-16 lg:grid-cols-12 lg:gap-20">
          <div className="lg:col-span-5">
            <div className="sticky top-28">
              <p
                data-testid="about-eyebrow"
                className="mb-6 font-body text-xs uppercase tracking-[0.4em] text-[#5C3A21]"
              >
                — {t.about.eyebrow}
              </p>
              <h2
                data-testid="about-title"
                className="font-serif-display text-5xl leading-[1.05] text-[#1A1A1A] sm:text-6xl"
              >
                {t.about.title}
              </h2>

              <div className="mt-10 grid grid-cols-3 gap-4 border-t border-[#1A1A1A]/15 pt-8">
                {t.about.stats.map((s, i) => (
                  <div key={i} data-testid={`about-stat-${i}`}>
                    <div className="font-serif-display text-3xl text-[#1A1A1A] sm:text-4xl">
                      {s.num}
                    </div>
                    <div className="mt-2 font-body text-[10px] uppercase tracking-[0.2em] text-[#4A4A4A] leading-snug">
                      {s.label}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="relative overflow-hidden">
              <img
                src={ABOUT_IMG}
                alt="Telleixako Benta interior"
                className="h-[420px] w-full object-cover sm:h-[520px]"
                data-testid="about-image"
              />
            </div>
            <div className="mt-10 space-y-6 font-body text-base leading-relaxed text-[#1A1A1A] sm:text-lg">
              <p data-testid="about-p1">{t.about.p1}</p>
              <p data-testid="about-p2" className="text-[#4A4A4A]">
                {t.about.p2}
              </p>
              <p data-testid="about-p3" className="text-[#4A4A4A]">
                {t.about.p3}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
